<template>
    <div>
        <Tab name="4"></Tab>
        <div class="page-btns-box">
            <el-button
                v-if="$utils.have('/paid/save')"
                type="primary"
                icon="el-icon-plus"
                @click="$router.push({path: `/operation/video/strategy/add`})"
                size="small"
                >创建策略</el-button
            >
        </div>
        <div class="page-list-box">
            <el-table
                :data="tableData"
                border
                style="width: 100%"
                v-loading="fetchLoading"
                size="small"
                stripe
            >
                <el-table-column prop="name" label="策略名称"></el-table-column>
                <el-table-column label="收费对象类型"  width="120">
                    <template slot-scope="scope">
                        <p v-if="scope.row.type === 1">演出</p>
                        <p v-else-if="scope.row.type === 2">众筹</p>
                        <p v-else-if="scope.row.type === 3">周边</p>
                    </template>
                </el-table-column>
                <el-table-column prop="activityId" label="收费对象ID"  width="100"></el-table-column>
                <el-table-column prop="chargeName" label="收费对象名称" min-width="120" show-overflow-tooltip></el-table-column>
                <el-table-column prop="videoNum" label="绑定视频" width="80"></el-table-column>
                <el-table-column fixed="right" width="120" label="操作" >
                    <template slot-scope="scope">
                        <el-button
                            v-if="$utils.have('/advertising/info')"
                            type="text"
                            size="small"
                            icon="el-icon-edit"
                            @click="$router.push({path: `/operation/video/strategy/detail/${scope.row.id}`})"
                            >管理</el-button
                        >
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div v-if="tableData.length > 0" class="page-pagination-box">
            <el-pagination
                background
                @size-change="search"
                @current-change="fetch"
                :current-page.sync="params.pageNo"
                :page-sizes="$pageSizes"
                :page-size.sync="params.pageSize"
                layout="total, sizes, prev, pager, next"
                :total="totalCount || 0">
            </el-pagination>
        </div>
    </div>
</template>

<script>
import Tab from '../components/tab';
const defaultQuery = {
    pageNo: 1,
    pageSize: 15
};
export default {
    components: {
        Tab
    },
    data() {
        return {
            visible: false,
            params: {...defaultQuery},
            fetchLoading: false,
            tableData: [],
            totalCount: 0,
        };
    },
    mounted(){
        this.fetch();
    },
    methods: {
        async fetch() {
            this.fetchLoading = true;
            const response = await this.$request({
                url: "/paid/list",
                method: "POST",
                data: this.params,
            })
            const {state, msg, result} = response.data;
            this.fetchLoading = false;
            if (state != 1) return this.$message.error(msg);
            this.tableData = result.result;
            this.totalCount = result.totalCount;
        },
        //搜索
        search() {
            this.params.pageNo = 1;
            this.fetch();
        },
        //重置搜索
        reset() {
            this.params = {...defaultQuery};
            this.search();
        }
    },
};
</script>
